import * as React from 'react';
import withStyles, { StyledComponentProps } from 'react-jss'
import * as classNames from 'classnames';
import moreIcon from 'src/assets/icons/More.svg';
import closeIcon from 'src/assets/icons/Close.svg';
import fonts from 'src/Constants/fonts';
import responsive from 'src/Constants/responsive';
import spacing from 'src/Constants/spacing';

export type AccordionProps = React.HTMLAttributes<HTMLElement> & {
    openLegend: string;
    closeLegend: string;
    related: boolean;
    isOpen: boolean;
    toggle: (e: React.MouseEvent<HTMLAnchorElement>) => void;
};

const styles = {
    container: {
        position: 'relative'
    },
    legend: {
        position: 'sticky',
        top: 0,
        background: 'white',
        cursor: 'pointer'
    },
    legendPadding: {
        [responsive.Mobile]: {
            paddingBottom: spacing.ContentGutter.Mobile
        },
        [responsive.AfterMobile]: {
            paddingBottom: spacing.ContentGutter.Desktop
        }
    },
    iconWraaper: {
        display: 'inline-block',
        marginRight: 5,
        ...fonts.ExcelsiorLT
    },
    icon: {
        [responsive.Mobile]: { height: 9 },
        [responsive.AfterMobile]: { height: 13 }
    }
}
type Props =
    AccordionProps &
    StyledComponentProps<keyof typeof styles>;

// type State = {
//     isOpen: boolean
// };

class Accordion extends React.PureComponent<Props> {
    constructor(props: Props) {
        super(props);

        // this._toggleAccodion = this._toggleAccodion.bind(this);

        // this.state = {
        //     isOpen: false
        // }
    }
    public render() {
        const { classes, openLegend, closeLegend, children,
            related, toggle, isOpen, ...rest } = this.props;

        return (
            <section className={classNames(classes!.container, rest.className)}>
                <div
                    className={classNames(classes!.legend, (isOpen && !related) ? classes!.legendPadding : null)}

                >
                    <a onClick={toggle}>
                        {!isOpen ? <>
                            <span className={classes!.iconWraaper}>
                                [<img className={classes!.icon} src={moreIcon} alt="plus icon" />]
                                </span>
                            <span>{openLegend}</span>
                        </> :
                            <>
                                <span className={classes!.iconWraaper}>
                                    [<img className={classes!.icon} src={closeIcon} alt="close icon" />]
                                </span>
                                <span>{closeLegend}</span>
                            </>
                        }
                    </a>
                </div>
                {isOpen && children}
            </section>
        );
    }

    // private _toggleAccodion(e: React.MouseEvent<HTMLAnchorElement>) {
    //     e.preventDefault();
    //     e.stopPropagation();
    //     this.setState(prev => ({ isOpen: !prev.isOpen }));
    // }
}

export default withStyles(styles)(Accordion);


// WEBPACK FOOTER //
// ./src/Components/Accordion.tsx